<script setup lang="ts">
import breadcrumb from '#layers/ui/theme/components/breadcrumb';
</script>

<template>
	<div class="truncate text-sm font-semibold" :class="breadcrumb.slots.item">
		<slot />
	</div>
</template>
